interface ConnectionBadgeProps {
  readonly status: "connected" | "reconnecting";
}

export function ConnectionBadge({ status }: ConnectionBadgeProps) {
  return (
    <div
      data-testid="horror-connection-pill"
      className="flex items-center gap-1.5"
    >
      <div
        className="h-[7px] w-[7px] shrink-0 rounded-full"
        style={{
          backgroundColor:
            status === "connected"
              ? "var(--cn-horror-p5)"
              : "var(--cn-horror-p2)",
          boxShadow:
            status === "connected"
              ? "0 0 6px var(--cn-horror-p5)"
              : "0 0 6px var(--cn-horror-p2)",
        }}
      />
      <span
        className="text-[11px]"
        style={{ color: "var(--cn-horror-text-muted)" }}
      >
        {status === "connected" ? "연결됨" : "재연결 중..."}
      </span>
    </div>
  );
}
